import React from 'react';
import { View } from 'react-native';
import { Loading } from '@shared/components/loading';
import LoadingSpinner from '@shared/components/md-design-system/Layout/LoadingSpinner';
import { Text } from '@shared/components/text';
import { useI18n } from '@shared/i18n/useI18n';
import { CHAT_SKELETON, CHAT_SKELETON_KEY } from '../../constants';
import { useChatRetry } from '../../contexts';
import { useDelayedVisible } from '../../hooks/useDelayedVisible';
import { useLoadTimeout } from '../../hooks/useLoadTimeout';
import { ChatChannelSkeletonRow } from './ChatChannelSkeletonRow';

export const ChatChannelListSkeleton = () => {
    const { t } = useI18n();
    const retry = useChatRetry();
    const visible = useDelayedVisible(CHAT_SKELETON.delayMs, CHAT_SKELETON_KEY.list);
    const timedOut = useLoadTimeout(CHAT_SKELETON.loadTimeoutMs);

    if (timedOut && retry) return <Loading message={t('screens.chat.list.error.title')} onRetry={retry} />;

    if (!visible) return <View className="flex-1 bg-white" />;

    return (
        <View className="flex-1 bg-white">
            {Array.from({ length: CHAT_SKELETON.listRows }).map((_, index) => (
                <ChatChannelSkeletonRow key={index} dimmed={index > 0} />
            ))}
            <View
                style={{ height: CHAT_SKELETON.loadingMoreHeight }}
                className="flex-row items-center justify-center gap-2"
            >
                <LoadingSpinner size="small" color="secondary" />
                <Text className="text-sm font-normal text-gray-500">{t('screens.chat.list.loadingMore')}</Text>
            </View>
        </View>
    );
};
